// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumValues_metrics_pm__vmI2X","column_metrics":"MemorandumValues_column_metrics__o6M6L"};